var map = {
	"./en-US.js": [
		"./src/i18n/en-US.js",
		"src_i18n_en-US_js"
	],
	"./field/en-US.js": [
		"./src/i18n/field/en-US.js",
		"src_i18n_field_en-US_js"
	],
	"./field/ja.js": [
		"./src/i18n/field/ja.js",
		"src_i18n_field_ja_js"
	],
	"./field/zh-TW.js": [
		"./src/i18n/field/zh-TW.js",
		"src_i18n_field_zh-TW_js"
	],
	"./ja.js": [
		"./src/i18n/ja.js",
		"src_i18n_ja_js"
	],
	"./loader.js": [
		"./src/i18n/loader.js"
	],
	"./zh-TW.js": [
		"./src/i18n/zh-TW.js",
		"src_i18n_zh-TW_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/i18n lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;